import styled from 'styled-components';
import media from '../../../constants/media';
import {Column} from "../../base/grid";

export const OptionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 3rem;
	border: 1px solid #e8e8e8;
	box-sizing: border-box;
	cursor: pointer;
	height: 100%;
	:hover {
		box-shadow: 4px 4px 6px 1px rgba(241, 241, 241, 0.8);
	}

	${media.tablet`
		padding: 4rem 4rem;
		min-height: 28.5rem;
	`};

	${media.desktopSmall`
		min-height: 26rem;
	`}
`;

export const ContentWrapper = styled.div`
	svg {
		height: 50px;
	}
`;

export const StyledColumn = styled(Column)`

	${media.desktopSmall`
		:nth-child(2) { order: 1 }
		:nth-child(4) {order: 1}	
	`}
`;

export const InfoWrapper = styled.div`
	font-size: 1.5rem;
	justify-content: space-between;
	padding: 1.5rem 3.5rem;
	background-color: #e8e8e8;
	margin-bottom: 3rem;
`;
